import React from 'react';
import { ShieldCheckIcon, CreditCardIcon, LandmarkIcon, ClockIcon, LockIcon } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-[#0a0716] pt-16 pb-8 border-t border-dark-border" data-id="element-33">
      <div className="max-w-6xl mx-auto px-4" data-id="element-34">
        <div className="flex flex-wrap justify-center gap-6 md:gap-12 text-sm text-gray-400 font-medium mb-16 border-b border-dark-border/50 pb-12" data-id="element-35">
          <span className="flex items-center gap-2" data-id="element-36">
            <LockIcon size={18} className="text-primary" data-id="element-37" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-38">
            <ClockIcon size={18} className="text-primary" data-id="element-39" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-40">
            <ShieldCheckIcon size={18} className="text-primary" data-id="element-41" /> Garantía 7
            días
          </span>
          <span className="flex items-center gap-2" data-id="element-42">
            <LandmarkIcon size={18} className="text-primary" data-id="element-43" /> Mercado Pago
          </span>
          <span className="flex items-center gap-2" data-id="element-44">
            <CreditCardIcon size={18} className="text-primary" data-id="element-45" /> Transferencia
            bancaria
          </span>
        </div>

        <div className="text-center mb-12" data-id="element-46">
          <h3 className="text-2xl font-black text-white mb-4" data-id="element-47">
            🐾 Global Nova Pro
          </h3>
          <p className="text-gray-400 mb-2" data-id="element-48">
            El sistema N°1 para cuidadores de perros y gatos en Argentina.
          </p>
          <p className="text-gray-500 italic" data-id="element-49">
            Porque cuidar mascotas con profesionalismo no debería costarte la
            tranquilidad.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-500 mb-12" data-id="element-50">
          <a href="mailto:globalnovapro@gmail.com" className="hover:text-primary transition-colors" data-id="element-51">
            📧 globalnovapro@gmail.com
          </a>
          <span className="hover:text-primary transition-colors cursor-pointer" data-id="element-52">
            📱 @globalnovapro2026
          </span>
          <span className="hover:text-primary transition-colors cursor-pointer" data-id="element-53">
            🌐 globalnovapro.shop
          </span>
        </div>

        <div className="text-center text-xs text-gray-600" data-id="element-54">
          <p className="mb-4" data-id="element-55">
            © Global Nova Pro™ 2025 — Todos los derechos reservados. Prohibida
            la reproducción y redistribución sin autorización expresa.
          </p>
          <p className="text-primary font-medium italic text-sm" data-id="element-56">
            "El próximo servicio puede ser el primero con respaldo real." 🐾
          </p>
        </div>
      </div>
    </footer>;
};